import type { SVGProps } from 'react';

export type RudderstackIconProps = SVGProps<SVGSVGElement>;

export const RudderstackIcon = ({ className, ...props }: RudderstackIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 41.4019 41.7106"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M41.4019 0H0C0 22.0234 17.1458 40.2401 39.1288 41.5728L41.4019 41.7106V0Z"
        fill="#020E20"
      />
    </svg>
  );
};
